import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { realtimeDatabase } from "../../database/firebase";
import { ref, onValue, update } from 'firebase/database';
import { getFirestore, increment, serverTimestamp, doc, getDoc, updateDoc, addDoc, setDoc, collection, query, orderBy, where, getDocs, onSnapshot, listCollections, Timestamp } from "firebase/firestore";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import Swal from "sweetalert2"; // Import SweetAlert2 for better UI feedback
import './userpage.css';



function UserPage({ updateHeader }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [userData, setUserData] = useState(null);
  const [themeData, setThemeData] = useState(null);
  const [riddlerusLogo, SetriddlerusLogo] = useState("/img/logo.png");
  const storedUserData = JSON.parse(sessionStorage.getItem('userData'));
  //const themeData1 = JSON.parse(sessionStorage.getItem('themeData'));
  const [rules, setRules] = useState(["", "", ""]);
  const [textcolor, Setcolorcode] = useState(null);
  const [apiGametype, setApiGametype] = useState(null); // 'tournament' | 'live' | null (null = show all)
  const inviteHandledRef = useRef(null);

  // Set user as not live when on userpage so they don't appear in allusers live list
  useEffect(() => {
    if (!realtimeDatabase || !userData?.sessionId || !userData?.userId) return;
    const userRef = ref(realtimeDatabase, `sessions/${userData.sessionId}/users/${userData.userId}`);
    update(userRef, { islive: false, live: false }).catch(() => {});
  }, [userData?.sessionId, userData?.userId]);

  // Listen for 2v2 room invites (from Invite People in game lobby)
  useEffect(() => {
    if (!realtimeDatabase || !userData?.sessionId || !userData?.userId) return;

    const userRef = ref(realtimeDatabase, `sessions/${userData.sessionId}/users/${userData.userId}`);
    const unsubscribe = onValue(userRef, (snapshot) => {
      if (!snapshot.exists()) return;
      const data = snapshot.val();
      const invite = data.pendingRoomInvite;
      if (!invite || !invite.roomCode) return;
      const key = `${invite.roomCode}-${invite.timestamp}`;
      if (inviteHandledRef.current === key) return;
      inviteHandledRef.current = key;

      Swal.fire({
        title: '2v2 Room Invite',
        html: `<strong>${invite.inviterName || 'Someone'}</strong> invited you to join 2v2 room <strong>${invite.roomCode}</strong>. Accept?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Accept',
        cancelButtonText: 'Reject',
        background: '#1e1e2d'
      }).then(async (result) => {
        if (result.isConfirmed) {
          const storedSession = sessionStorage.getItem("userData");
          if (storedSession) {
            const parsedUser = JSON.parse(storedSession);
            const updatedUser = { ...parsedUser, gametype: 'live-2v2' };
            sessionStorage.setItem("userData", JSON.stringify(updatedUser));
            setUserData(updatedUser);
          }
          try {
            await update(userRef, { pendingRoomInvite: null });
          } catch (e) {
            console.error('Error clearing invite:', e);
          }
          navigate(`/game?gameId=${invite.roomCode}`);
        } else {
          try {
            await update(userRef, { pendingRoomInvite: null });
            const inviterRef = ref(realtimeDatabase, `sessions/${userData.sessionId}/users/${invite.inviterId}`);
            await update(inviterRef, {
              roomInviteRejected: {
                by: userData.userId,
                byName: userData.name || userData.firstName || 'A player',
                roomCode: invite.roomCode,
                timestamp: Date.now(),
              },
            });
          } catch (e) {
            console.error('Error clearing invite:', e);
          }
        }
      });
    });

    return () => unsubscribe();
  }, [userData?.sessionId, userData?.userId, navigate]);

  useEffect(() => {

    updateHeader({
      backButtonRedirect: "/intro"
    });

    const fetchData = async () => {
      const storedSession = sessionStorage.getItem("userData");
      console.log(storedSession);
      const storedTheme = sessionStorage.getItem("themeData");

      if (storedSession && storedTheme) {
        const parsedUser = JSON.parse(storedSession);
        const parsedTheme = JSON.parse(storedTheme);
        console.log(parsedTheme);

        setUserData(parsedUser);
        setThemeData(parsedTheme);
        setRules(parsedTheme.rules); // ✅ Set rules correctly
        Setcolorcode(parsedTheme.landing_page_title_color);
        console.log("Theme Rules:", parsedTheme.rules);
      } else {
        navigate("/login"); // Redirect if session data is missing
      }
    };

    fetchData();
  }, [navigate]);

  // Fetch match type from API to show/hide 1v1, 2v2, tournament
  useEffect(() => {
    if (!userData?.sessionId || !userData?.organizationId) return;
    if (String(userData.sessionId).toLowerCase() === 'demobypass') return;
    const fetchMatchType = async () => {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_PHP_ADMIN_BASE_URL}getMatchType.php`,
          {
            sessionId: userData.sessionId,
            organizationId: userData.organizationId,
          },
          { headers: { 'Content-Type': 'application/json' } }
        );
        const data = res?.data?.data;
        const success = res?.data?.response?.success;
        if (success && data?.gametype) {
          setApiGametype(data.gametype);
        } else {
          // When gametype is not available, call events-game API with getmatchtype event
          try {
            const eventsRes = await axios.post(
              `${process.env.REACT_APP_PHP_ADMIN_BASE_URL}events-game.php?events=getmatchtype`,
              {
                sessionId: userData.sessionId,
                organizationId: userData.organizationId,
                gameId: userData.gameId || ""
              },
              { headers: { 'Content-Type': 'application/json' } }
            );
            const eventsSuccess = eventsRes?.data?.success;
            const eventsGametype = eventsRes?.data?.gametype;
            if (eventsSuccess && eventsGametype) {
              setApiGametype(eventsGametype);
            } else {
              setApiGametype(null);
            }
          } catch (eventsErr) {
            console.error('events-game getmatchtype error:', eventsErr);
            setApiGametype(null);
          }
        }
      } catch (err) {
        console.error('getMatchType error:', err);
        setApiGametype(null);
      }
    };
    fetchMatchType();
  }, [userData?.sessionId, userData?.organizationId, userData?.gameId]);

  const isDemoBypassSession =
    userData?.sessionId != null && String(userData.sessionId).toLowerCase() === 'demobypass';

  useEffect(() => {
    if (themeData != null) {
      const body = document.body;

      if (body.classList.contains('common-bg')) {
        // Check if it's a mobile device (or you can define your own breakpoint)
        if (window.innerWidth <= 768) {
          // Apply mobile background
          console.log(themeData.background_mob);
          body.style.backgroundImage = `url(${themeData.background_mob})`;
        } else {
          // Apply desktop background
          console.log(themeData.background_desk);
          body.style.backgroundImage = `url(${themeData.background_desk})`;
        }
      }
      SetriddlerusLogo(themeData.logo);
    }
  }, [themeData]);

    const playWithComputer = async () => {
    try {
      // Ensure we have userData and persist gametype = '1vcpu'
      const storedSession = sessionStorage.getItem("userData");
      if (!storedSession) {
        navigate("/login");
        return;
      }

      const parsedUser = JSON.parse(storedSession);
      const updatedUser = { ...parsedUser, gametype: '1vcpu' };

      sessionStorage.setItem("userData", JSON.stringify(updatedUser));
      setUserData(updatedUser);

      navigate(`/game`);
    } catch (error) {
      console.error('Error starting AI game:', error);
    }
  };

  const playTournament = async () => {
    try {
      // Ensure we have userData and persist gametype = 'tournament'
      const storedSession = sessionStorage.getItem("userData");
      if (!storedSession) {
        navigate("/login");
        return;
      }

      const parsedUser = JSON.parse(storedSession);
      const updatedUser = { ...parsedUser, gametype: 'tournament' };

      sessionStorage.setItem("userData", JSON.stringify(updatedUser));
      setUserData(updatedUser);

      navigate(`/tournament`);
    } catch (error) {
      console.error('Error starting tournament:', error);
    }
  };

  const play1v1 = async () => {
    try {
      // Ensure we have userData and persist gametype = '1v1'
      const storedSession = sessionStorage.getItem("userData");
      if (!storedSession) {
        navigate("/login");
        return;
      }

      const parsedUser = JSON.parse(storedSession);
      const updatedUser = { ...parsedUser, gametype: '1v1' };

      sessionStorage.setItem("userData", JSON.stringify(updatedUser));
      setUserData(updatedUser);

      navigate(`/allusers`);
    } catch (error) {
      console.error('Error starting 1v1 game:', error);
    }
  };

  // const play2v2 = async () => {
  //   try {
  //     // Ensure we have userData and persist gametype = '2v2'
  //     const storedSession = sessionStorage.getItem("userData");
  //     if (!storedSession) {
  //       navigate("/login");
  //       return;
  //     }

  //     const parsedUser = JSON.parse(storedSession);
  //     const updatedUser = { ...parsedUser, gametype: 'live-2v2' };

  //     sessionStorage.setItem("userData", JSON.stringify(updatedUser));
  //     setUserData(updatedUser);

  //     navigate(`/game`);
  //   } catch (error) {
  //     console.error('Error starting 2v2 game:', error);
  //   }
  // };

  const play2v2 = () => {
    Swal.fire({
      title: 'Coming Soon',
      text: '2v2 mode is under development. Stay tuned!',
      icon: 'info',
      confirmButtonText: 'OK',
      background: '#1e1e2d'
    });
  };

  return (
    <div className="userpage-container">

      <div className="game-modes-section">
        <h2 className="section-title" style={{ color: textcolor }}>Choose Your Game Mode</h2>
        <div className="game-modes-container">

          <div className="game-modes-overlay">
            {isDemoBypassSession && (
              <div className="mode-card" data-mode="cpu" onClick={playWithComputer}>
                <img src="/img/playcomputer.png" alt="Play vs computer" className="game-modes-image" />
              </div>
            )}
            {!isDemoBypassSession && apiGametype === 'live' && (
              <>
                {console.log('=== DEBUG LIVE MODE ===')}
                {console.log('apiGametype:', apiGametype)}
                {console.log('themeData:', themeData)}
                {console.log('themeData type:', typeof themeData)}
                {console.log('1v1 value:', themeData?.['1v1'], 'type:', typeof themeData?.['1v1'])}
                {console.log('1vcpu value:', themeData?.['1vcpu'], 'type:', typeof themeData?.['1vcpu'])}
                {console.log('2v2 value:', themeData?.['2v2'], 'type:', typeof themeData?.['2v2'])}
                {console.log('=======================')}
                
                {/* Show tabs if themeData is null (fallback) or if boolean true */}
                {(!themeData || themeData?.['1v1'] === true) && (
                  <div className="mode-card" data-mode="1v1" onClick={play1v1}>
                    <img src="/img/1v1.png" alt="Carrom Game Modes" className="game-modes-image" />
                  </div>
                )}
                {(!themeData || themeData?.['1vcpu'] === true) && (
                  <div className="mode-card" data-mode="cpu" onClick={playWithComputer}>
                    <img src="/img/playcomputer.png" alt="Carrom Game Modes" className="game-modes-image" />
                  </div>
                )}
                {(!themeData || themeData?.['2v2'] === true) && (
                  <div className="mode-card" data-mode="2v2" onClick={play2v2}>
                    <img src="/img/2v2.png" alt="Carrom Game Modes" className="game-modes-image" />
                  </div>
                )}
              </>
            )}
            {!isDemoBypassSession && apiGametype === 'tournament' && (
              <>
                <div className="mode-card" data-mode="tournament" onClick={playTournament}>
                  <img src="/img/tournament.png" alt="Carrom Game Modes" className="game-modes-image" />
                </div>
                
                {themeData?.['2v2'] === true && (
                  <div className="mode-card" data-mode="2v2" onClick={play2v2}>
                    <img src="/img/2v2.png" alt="Carrom Game Modes" className="game-modes-image" />
                  </div>
                )}
                {themeData?.['1vcpu'] === true && (
                  <div className="mode-card" data-mode="cpu" onClick={playWithComputer}>
                    <img src="/img/playcomputer.png" alt="Carrom Game Modes" className="game-modes-image" />
                  </div>
                )}
              </>
            )}
            {!isDemoBypassSession && apiGametype === null && (
              <>
                <div className="mode-card" data-mode="1v1" onClick={play1v1}>
                  <img src="/img/1v1.png" alt="Carrom Game Modes" className="game-modes-image" />
                </div>
                <div className="mode-card" data-mode="cpu" onClick={playWithComputer}>
                  <img src="/img/playcomputer.png" alt="Carrom Game Modes" className="game-modes-image" />
                </div>
                <div className="mode-card" data-mode="2v2" onClick={play2v2}>
                  <img src="/img/2v2.png" alt="Carrom Game Modes" className="game-modes-image" />
                </div>
                <div className="mode-card" data-mode="tournament" onClick={playTournament}>
                  <img src="/img/tournament.png" alt="Carrom Game Modes" className="game-modes-image" />
                </div>
              </>
            )}
          </div>
        </div>
      </div>

    </div>

  );
}

export default UserPage;
